import { CalendarWidget } from 'src/UI';
import { FC } from 'react';
import { Hint } from '@redoc/ui-kit';
import { IFilterProps } from '.';
import { ReactComponent as DateIcon } from '../../assets/calendar.svg';
import Button from 'src/Components/Button';
import classNames from 'classnames';
import DateFormater from 'src/Utils/DateFormater';
import st from './DefFilterCommon.module.scss';

/** Компонента фильтра по дате */
const Date: FC<IFilterProps> = (props) => {
	const {
		columnId,
		isShowModal,
		value,
		setValue,
		cancelHandler,
		applyValueHandler,
	} = props;

	/** Подготовка массива дат для виджета */
	const prepareValuesForWidget = () => {
		const vals: (Date | null)[] = [];
		if (!!value && Array.isArray(value) && !!value.length) {
			value.forEach((date) => {
				if (!!date && typeof date === 'string') {
					vals.push(DateFormater.getDate(date));
				} else {
					vals.push(date);
				}
			});
		}
		return vals;
	};

	/** Подготовка строки для инпута таблицы */
	const prepareValuesForInput = () => {
		const vals: string[] = [];
		if (!!value && Array.isArray(value) && !!value.length) {
			value.forEach((date) => {
				if (!!date && typeof date === 'string') {
					vals.push(DateFormater.toShortString(date));
				} else {
					vals.push('');
				}
			});
			return vals.length > 1 ? vals.join(' - ') : vals[0];
		}
		return '';
	};

	/** Рендер кнопок отмена/применить */
	const renderButtons = () => {
		return (
			<div className={st.modalButtons}>
				<Button
					id={'filter_cancel-' + columnId}
					onClick={cancelHandler}
					variant="red"
					outline
				>
					Отмена
				</Button>
				<Button
					id={'filter_apply-' + columnId}
					onClick={applyValueHandler}
				>
					Применить
				</Button>
			</div>
		);
	};

	const textValue = prepareValuesForInput();
	return (
		<>
			<DateIcon />
			<Hint
				messageText={textValue}
				placement="top"
				disabled={!textValue}
			>
				<input className="body-small" readOnly value={textValue} />
			</Hint>

			{isShowModal && (
				<div className={classNames(st.modalBody, st.calendar)}>
					<CalendarWidget
						selectType="between"
						autoFocusFirstInput
						values={prepareValuesForWidget()}
						renderBottomToolbar={renderButtons}
						onValuesChange={setValue}
					/>
				</div>
			)}
		</>
	);
};

export default Date;
